/**
 * Defines properties for a toast notfication
 */
export default interface ToastNotificationInterface {
    id: number;
    title: string;
    description: string;
    type: ToastNotificationType;
}

/**
 * String values based on patternfly component alrt.variant
 * https://www.patternfly.org/v4/components/alert/
 */
export enum ToastNotificationType {
    Default = "default",
    Info = "info",
    Success = "success",
    Warning = "warning",
    Danger = "danger"
}